/* eslint-disable react-hooks/exhaustive-deps */
import {Communication} from "types/communication"
import styles from "./Notes.module.css"
import cx from "classnames"
import {useEffect, useState} from "react"
import {chatServiceV2} from "services"
import {TopicDetailsPanel} from "./part"
import {Topics} from "./part/Topics"
import {useVisible} from "hooks"
import {useQuery} from "@tanstack/react-query"

type Props = {
    studentProfileId: number
}

export function Notes(props: Props) {
    const {studentProfileId} = props
    const topicDetailsVisible = useVisible(false)
    const [selectedTopic, setSelectedTopic] = useState<Communication.ChannelTopic | undefined>()

    const {data: studentRoomId} = useQuery(
        ["student-channel", studentProfileId],
        async () => {
            const channelInfo = await chatServiceV2.getStudentChannel({studentProfileId: studentProfileId})
            return channelInfo?.roomId
        },
        {enabled: !!studentProfileId}
    )

    useEffect(() => {
        setSelectedTopic(undefined)
        topicDetailsVisible.close()
    }, [studentProfileId])

    return (
        <div className={styles.containerWrap}>
            <div className={styles.container}>
                <div className={cx(styles.heading)}>
                    <div className={cx(styles.titleWrap)}>
                        <span className={styles.title}>Student Notes</span>
                    </div>
                </div>
                <div className={styles.contentContainer}>
                    <div className={styles.threadContainer}>
                        <Topics
                            studentRoomId={studentRoomId}
                            onSelectTopic={(topic) => {
                                setSelectedTopic(topic)
                                topicDetailsVisible.open()
                            }}
                            activeTopic={selectedTopic}
                        />
                    </div>
                </div>
            </div>
            <TopicDetailsPanel
                topic={selectedTopic}
                visible={topicDetailsVisible.isVisible}
                onClose={() => {
                    topicDetailsVisible.close()
                    setSelectedTopic(undefined)
                }}
            />
        </div>
    )
}
